import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const addModuleToSelectionValidationSchema = t => ({
  selectedModules: yup
    .mixed()
    .required(t(translations.validation.required()))
    .label(t(translations.pages.moduleSelectionsDetail.modulePreview.create.selectModulesField()))
    .test(
      'selected_modules_invalid',
      t(translations.pages.moduleSelectionsDetail.modulePreview.create.invalidError()),
      item => item instanceof Set && item.size > 0
    )
});
